import React from "react";
import { motion } from "framer-motion";
import Mission1 from "../assets/Mission1.png";
import Mission2 from "../assets/Mission2.png";
import Mission3 from "../assets/Mission3.png";

const container = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, staggerChildren: 0.25 },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const Mission = () => {
  return (
    <motion.section
      className="bg-white w-full py-16 md:py-24"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-50px" }}
      variants={container}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 text-center">
        
        {/* Title */}
        <motion.h2
          variants={item}
          className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
        >
          Our Mission
        </motion.h2>

        {/* Description */}
        <motion.p
          variants={item}
          className="text-gray-600 max-w-3xl mx-auto mb-12 leading-relaxed"
        >
          We work with individuals from diverse backgrounds — including children,
          adolescents, adults, and families — both in clinical settings and
          community programs. Our approach is empathetic, patient, and
          collaborative. Together, we understand, heal, and grow.
        </motion.p>

        {/* Image Grid */}
        <motion.div
          variants={container}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {/* Card 1 */}
          <motion.div
            variants={item}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 200 }}
            className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all"
          >
            <img
              src={Mission1}
              alt="Therapy session"
              className="w-full h-80 object-cover"
            />
          </motion.div>

          {/* Card 2 */}
          <motion.div
            variants={item}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 200 }}
            className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all"
          >
            <img
              src={Mission2}
              alt="Online consultation"
              className="w-full h-80 object-cover"
            />
          </motion.div>

          {/* Card 3 */}
          <motion.div
            variants={item}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 200 }}
            className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all"
          >
            <img
              src={Mission3}
              alt="Happy woman on call"
              className="w-full h-80 object-cover"
            />
          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Mission;
